import * as React from 'react'

import TawkMessengerReact, { TawkChat } from '@tawk.to/tawk-messenger-react'
import { useUser } from 'components/hooks/state'

interface SupportContextI {
    toggleChatWidget: () => void
    isChatWidgetVisible: boolean
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const SupportContext = React.createContext<SupportContextI>()

interface SupportProviderProps {
    children: React.ReactNode
}

// https://github.com/tawk/tawk-messenger-react/blob/main/docs/api-reference.md

export const SupportProvider = ({ children }: SupportProviderProps) => {
    const chatRef = React.useRef<TawkChat>()
    const [isChatWidgetVisible, setIsChatWidgetVisible] = React.useState(false)
    const [isChatMaximized, setIsChatMaximized] = React.useState(false)

    const { user } = useUser()

    const onChatLoad = () => {
        if (!chatRef.current) return

        chatRef.current.hideWidget()

        chatRef.current.setAttributes({
            name: user?.first_name,
            email: user?.email,
        })
    }

    const showChatWidget = () => {
        if (!chatRef.current) return

        chatRef.current.showWidget()
        setIsChatWidgetVisible(true)

        if (!isChatMaximized) {
            setTimeout(() => {
                if (!chatRef.current) return
                chatRef.current.maximize()
                setIsChatMaximized(true)
            }, 10)
        }
    }

    const hideChatWidget = () => {
        if (!chatRef.current) return

        if (isChatMaximized) {
            chatRef.current.minimize()
            setIsChatMaximized(false)
        }

        setTimeout(() => {
            if (!chatRef.current) return
            chatRef.current.hideWidget()
            setIsChatWidgetVisible(false)
        }, 10)
    }

    const toggleChatWidget = () => {
        if (!isChatWidgetVisible) {
            showChatWidget()
        } else {
            hideChatWidget()
        }
    }

    return (
        <SupportContext.Provider value={{ toggleChatWidget, isChatWidgetVisible }}>
            <TawkMessengerReact
                onLoad={onChatLoad}
                ref={chatRef}
                propertyId="6410ea2c31ebfa0fe7f2999a"
                widgetId="1grh15g6r"
            />
            {children}
        </SupportContext.Provider>
    )
}

export const SupportConsumer = SupportContext.Consumer

export const useSupport = () => {
    return React.useContext(SupportContext)
}
